import type {
  RadioGroupProps as MantineRadioGroupProps,
  RadioProps as MantineRadioProps} from '@mantine/core';
import {
  Radio as MantineRadio
} from '@mantine/core';

function RadioGroup({ children, ...props }: MantineRadioGroupProps) {
  return <MantineRadio.Group {...props}>{children}</MantineRadio.Group>;
}

function Radio({ ...props }: MantineRadioProps) {
  return <MantineRadio {...props} />;
}

export { Radio, RadioGroup };
